<div class="modal-header">
  <h2 class="modal-title mb-0 fs-3 fw-bold">
    {{
      'title.payment-status-change' | translate : {
        bookingReference: data.bookingReference
      }
    }}
  </h2>
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" [attr.aria-label]="'button.close' | translate"></button>
</div>
<div class="modal-body table-page-component">
  <form>
    <p>
      {{ 'change-payment-status.current-status-label' | translate }}
      <strong>{{ 'booking.' + tenant + '.status.' + data.currentPaymentStatus | lowercase | translate }}</strong>
    </p>
    <app-form-field-select
      [field]="targetPaymentStatusControl"
      [options]="targetPaymentStatusOptions"
      label="change-payment-status.target-status-label"
    ></app-form-field-select>
  </form>

  <div *ngIf="targetPaymentStatusControl.value === 'open'">
    <p>
      {{ 'change-payment-status.payment-expected-until' | translate }}
    </p>
    <app-form-field-datetime
      [field]="paymentExpectedByControl"
      [min]="earliestPossiblePayment"
      [max]="latestPossiblePayment"
      label="change-payment-status.payment-expected-until-label"
    ></app-form-field-datetime>
  </div>

  <div>
    <p>
      {{ 'change-payment-status.comment-label' | translate }}
    </p>
    <app-form-field-textarea
      [field]="paymentStatusChangeCommentControl"
      class="status-change-comment"
    ></app-form-field-textarea>
  </div>
</div>
<div class="modal-footer justify-content-between">
  <button
    class="btn btn-outline-primary"
    (click)="bsModalRef.hide()"
  >
    {{ 'button.cancel' | translate }}
  </button>
  <button
    class="btn btn-warning"
    (click)="changePaymentStatus()"
    [disabled]="!targetPaymentStatusControl.value"
  >
    {{ 'button.payment-status-change' | translate }}
  </button>
</div>
